export var Size;
(function (Size) {
    Size["None"] = "none";
    Size["Tiny"] = "tiny";
    Size["Smallest"] = "smallest";
    Size["Smaller"] = "smaller";
    Size["Small"] = "small";
    Size["Normal"] = "normal";
    Size["Large"] = "large";
    Size["Larger"] = "larger";
    Size["Largest"] = "largest";
    Size["Huge"] = "huge";
})(Size || (Size = {}));
//# sourceMappingURL=IPadding.js.map